import Logo from "../../../../assets/Discount_App_logo.png";

import { CMS } from "../../services/auth.services";
import { useState, useEffect } from "react";

export default function BusinessTermsAndConditions() {
  const [termsAndConditions, setTermsAndConditions] = useState(null);

  useEffect(() => {
    async function getData() {
      try {
        const response = await CMS({ values: {}, slug: "terms_condition" });
        if (response?.success) {
          document.title = response.data.title;
          setTermsAndConditions(response.data);
        }
      } catch (error) {
        console.error("Error fetching terms:", error);
        setTermsAndConditions(null);
      }
    }
    getData();
  }, []);

  return (
    <div className="cms-content-pages">
      <div className="cms-header shadow-sm bg-body-tertiary py-3">
        <div className="container">
          <div className="cms-header-in">
            <div className="cms-logo">
              <a href="#">
                <img src={Logo} alt="logo-img" width={60} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="setup-box mx-auto">
        <h4 className="h4-headline text-center mb-4">Terms and Conditions</h4>
        {!termsAndConditions ? <p>Loading terms and conditions...</p> : <div dangerouslySetInnerHTML={{ __html: termsAndConditions.description }} />}
      </div>
    </div>
  );
}
